exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_loading__3tDeM {\n  height: 100%;\n  width: 100%; }\n\n.styles_container__2DwGI {\n  flex: 1 1;\n  width: 500px;\n  height: 200px; }\n\n.styles_mapContainer__3yYBR {\n  flex: 1 1;\n  width: 1000px;\n  height: 400px; }\n\n.styles_map__18MJi {\n  height: 100%; }\n\n.styles_filter-container__PAEvg {\n  left: 5px;\n  bottom: 35px; }\n\n.styles_textMapFilter__3KEBO {\n  color: #4D7387; }\n\n.styles_label-check__2H84v {\n  padding: 0; }\n\n.styles_hide__2JkMm {\n  display: none; }\n\n.styles_filterContainer__29KIs {\n  margin-top: -50px;\n  margin-left: 10px; }\n\n@media only screen and (max-width: 820px) {\n  .styles_container__2DwGI.styles_is-single__1abzD {\n    display: block;\n    height: 65vh; }\n  .styles_filterContainer__29KIs {\n    display: none; } }\n", ""]);

// Exports
exports.locals = {
	"loading": "styles_loading__3tDeM",
	"container": "styles_container__2DwGI",
	"mapContainer": "styles_mapContainer__3yYBR",
	"map": "styles_map__18MJi",
	"filter-container": "styles_filter-container__PAEvg",
	"filterContainer": "styles_filter-container__PAEvg",
	"textMapFilter": "styles_textMapFilter__3KEBO",
	"label-check": "styles_label-check__2H84v",
	"labelCheck": "styles_label-check__2H84v",
	"hide": "styles_hide__2JkMm",
	"filterContainer": "styles_filterContainer__29KIs",
	"is-single": "styles_is-single__1abzD",
	"isSingle": "styles_is-single__1abzD"
};